/* eslint-disable */
// eslint conflicts in auto vue create config
import Vue from "vue";
import axios from "axios";
import ROUTE from "~/constants/routes";
import router from "~/router";
import keysToCamelCase from "camelcase-keys";
// import keysToSnakeCase from "snakecase-keys";
import { getAccessToken, logOut, setTokenData } from "~/helpers/userAuth";
import { getSiteKey } from "~/helpers/userAuth";

const config = {
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  baseURL: process.env.VUE_APP_API,
  // baseURL: "https://api.thegoodocs.com/v1",
  withCredentials: false,
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  (config) => {
    //Authorization

    if (getAccessToken()) {
      config.headers.Authorization = `Bearer ${getAccessToken()}`;
    }

    if (getSiteKey()) {
      config.headers.apikey = `${getSiteKey()}`;
    } else {
      config.headers.apikey = "sNmzWZvR7XsnyAP4";
    }

    //User id

    config.headers["user-id"] = "22";
    config.headers["x-page-id"] = "admin";

    // if (config.data) {
    //   config.data = keysToSnakeCase(config.data, { deep: true });
    // }

    return config;
  },
  // Do something before request is sent f
  (error) => {
    // if (error.response.status === 401) {
    //   logOut();
    // }
    Promise.reject(error);
  },
);

// Add a response interceptor
_axios.interceptors.response.use(
  (response) => {
    if (response.data) {
      response.data = keysToCamelCase(response.data, { deep: true });
    }
    return response;
  },
  async (error) => {
    const originalConfig = error.config;
    if (
      originalConfig.url !== "/user/login" &&
      originalConfig.url !== "/user/refresh" &&
      error.response.status === 401 &&
      getAccessToken()
    ) {
      // Access Token was expired
      if (error.response.status === 401 && !originalConfig._retry && getAccessToken()) {
        originalConfig._retry = true;

        try {
          const rs = await _axios.post("/user/refresh");

          setTokenData(rs.data.data.accessToken, rs.data.data.expiresIn);

          return _axios(originalConfig);
        } catch (_error) {
          logOut();
          // return Promise.reject(_error);
        }
      }
    }
    if (error.response.status === 403) {
      document.querySelector(".modal-accesses").classList.add("active");
    }
    if (error.response && error.response.data) {
      error.response.data = keysToCamelCase(error.response.data, { deep: true });
    }

    return Promise.reject(error);
  },
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
